import React, { useEffect, useState } from 'react';
import { Input, InputGroup, InputRightElement, InputProps, InputGroupProps } from '@chakra-ui/react';
import { LuSearch } from 'react-icons/lu';
import { useDebouncedCallback } from 'use-debounce';
import { toDigitsOnly } from '../utils/digitsValidation';

interface SearchFilterProps extends InputGroupProps {
  handleChange?: (value: string) => void;
  debounceDelay?: number;
  value?: string;
  placeholder?: string;
  inputType?: 'text' | 'number';
  digitsOnly?: boolean;
}

export const SearchFilter = ({ handleChange, value, placeholder = 'Buscar...', debounceDelay = 300, inputType = 'text', digitsOnly = false, ...props }: SearchFilterProps) => {
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const debouncedChange = useDebouncedCallback((val: string) => {
    handleChange?.(val);
  }, debounceDelay);

  const handleInputChange = (rawValue: string) => {
    const newValue = digitsOnly ? toDigitsOnly(rawValue) : rawValue;
    if (newValue === localValue) return;
    setLocalValue(newValue);
    debouncedChange(newValue);
  };

  return (
    <InputGroup {...props}>
      <InputRightElement>
        <LuSearch />
      </InputRightElement>
      <Input
        placeholder={placeholder}
        value={localValue}
        onChange={(e) => handleInputChange(e.target.value)}
        type={digitsOnly ? 'text' : inputType}
        inputMode={digitsOnly ? 'numeric' : undefined}
        pattern={digitsOnly ? '[0-9]*' : undefined}
      />
    </InputGroup>
  );
};
